module.exports = "/_next/static/images/phone-redeem-codes-cbc53dc6befb6ff3eb099f786d313645.jpg";